var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Text from "./Text";
import DaggerSymbol from "./DaggerSymbol";
var Sup = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "dagger" : _b, _c = _a.color, color = _c === void 0 ? "inherit" : _c, _d = _a.fontSize, fontSize = _d === void 0 ? ["0.4em", "0.4em", "0.55em"] : _d, children = _a.children, rest = __rest(_a, ["variant", "color", "fontSize", "children"]);
    var symbol = null;
    switch (variant) {
        case "dagger":
            symbol = React.createElement(DaggerSymbol, null);
            break;
        case "reg":
            symbol = React.createElement(React.Fragment, null, "\u00AE");
            break;
        case "trade":
            symbol = React.createElement(React.Fragment, null, "\u2122");
            break;
        default:
            symbol = null;
    }
    return (React.createElement(Text, __assign({ as: "sup", display: "inline", className: "oui-sup", fontSize: fontSize, color: color, verticalAlign: "top", "aria-hidden": "true" }, rest), children ? children : symbol));
};
export default Sup;
//# sourceMappingURL=Sup.js.map